<template>
    <AInesMessage v-if=introMessage :text-content="introMessage" />
</template>

<script setup lang="ts">

import AInesMessage from "@/views/Chat/AInesMessage.vue";
import {useChatStore} from "@/helper/chat/chatStore";
import {computed} from "vue";

const props = defineProps({
    fallbackMessage: {
        type: String,
        required: false,
        default: undefined
    }
})

const chatStore = useChatStore();
const introMessage = computed(() => {
    let assistantMessage
    if (chatStore.currentExpertRunMessageTextStreaming) {
        assistantMessage = chatStore.currentExpertRunMessageTextStreaming
    } else if (chatStore.scriptedMessage) {
        assistantMessage = chatStore.scriptedMessage.textContent
    }

    return assistantMessage || props.fallbackMessage || undefined
})

</script>
